import { temAcesso } from '@/shared/auth/temAcesso'

const PropostasPrecos = () => import('./PropostasPrecos.vue')
const NovaPropostaPreco = () => import('./PropostaPrecoForm.vue')
const DetalhePropostaPreco = () => import('./PropostaPrecoDetalhe.vue')

export default {
    path: '/propostas-precos',
    name: 'PropostasPrecos',
    component: PropostasPrecos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('PROP-PRECO-OBTER-00')) {
            next()
        }
    },
    children: [
        {
            path: 'nova',
            name: 'PropostasPrecos_Nova',
            component: NovaPropostaPreco,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PROP-PRECO-ADD-00')) {
                    next()
                }
            },
        },
        {
            path: ':propostaPrecoId/editar',
            name: 'PropostasPrecos_Editar',
            component: NovaPropostaPreco,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PROP-PRECO-ATU-00')) {
                    next()
                }
            },
        },
        {
            path: ':propostaPrecoId/detalhe',
            name: 'PropostasPrecos_Detalhe',
            component: DetalhePropostaPreco,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PROP-PRECO-OBTER-01')) {
                    next()
                }
            },
        },
    ]
}